import React, { useEffect, Suspense, useState } from "react";
import Background from "../Components/Background";
import Loader from "../Components/Loader";
import {
  arrayRemove,
  arrayUnion,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import placeholder from "../assets/image/cardplaceholder.gif"; // Import your placeholder image
import { db } from "../config/firebase";
import Carousel from "react-multi-carousel";
import responsive from "../Components/Responsive";
import MovieCard from "../Components/MovieCard";

const Favourites = ({ user }) => {
  const userDocRef = doc(db, "users", user.uid);
  const [favmovie, setFavmovie] = useState([]);
  const [favtv, setFavtv] = useState([]);

  const movfavfun = async () => {
    try {
      const docSnap = await getDoc(userDocRef);
      if (docSnap.exists()) {
        const userData = docSnap.data();
        setFavmovie(userData.profile?.favourites?.movie || []);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const tvfavfun = async () => {
    try {
      const docSnap = await getDoc(userDocRef);
      if (docSnap.exists()) {
        const userData = docSnap.data();
        setFavtv(userData.profile?.favourites?.tv || []);

      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    movfavfun();
    tvfavfun();
  }, []);

  return (
    <div>
      <div className="z-40 ml-7 mt-10 text-teal-50 flex flex-col relative   ">
        <div className="w-full flex flex-row justify-center items-center my-4"><div className="newfont text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text font-extrabold">FAVOURITES</div></div>
        <div className="flex w-full h-full">
          {favmovie.length > 0 ? (
            <>
             <div className="flex flex-row flex-wrap ">
              {
                favmovie && favmovie.map((e)=><><MovieCard movie={{
                  name:e.movieName,
                  id:e.movieId,
                  profile_path:e.movieImg
                }} filterType={{isMovieChecked:true}}/></> )
                
              }
              {
                favtv && favtv.map((e)=><MovieCard movie={{
                  name:e.tvName,
                  id:e.tvId,
                  profile_path:e.tvImg
                }} filterType={{isTvChecked:true}}/>)
              }
                 
             </div>
            </>
          ) : (
            <div className="newfont text-gray-300 font-extrabold">No Favourites Yet </div>

          )}
        </div>
      </div>
      <Background />
    </div>
  );
};

export default Favourites;
